// removed by extract-text-webpack-plugin
module.exports = {"ba-none":"magazines_3LDbi"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/styles.scss
// module id = 1027
// module chunks = 1